'use strict';

var _ = require('lodash');
var PubSub = require('tscom-pubsub');
var template = require('../templates/thanks.ejs');

var ThanksView = require('standard-vote/app/scripts/views/thanks');

module.exports = ThanksView.extend({

    render: function() {
        var scope = {};
        var model = this.voteOption;

        var text = this.controller.Models.Cms.get('text')[
            'views_vote_confirmation'
        ];
        var design = this.controller.Models.Cms.get('text')['design'];
        var twShare = this.controller.Models.Cms.get('text')['views_share']
            .twitter_copy;
        var shareSettings = this.controller.Models.Cms.get('text')[
            'views_share'
        ];

        //Parse through twitter share for first name and last name
        var firstName = model.firstname;
        var lastName = model.lastname;
        twShare = twShare.replace('{firstname}', firstName);
        twShare = twShare.replace('{lastname}', lastName);

        var contestant =
            lastName != '' ? firstName + ' ' + lastName : firstName;
        var twVoteText = text.twitter_vote.tweet_copy.replace(
            '{contestant}',
            contestant
        );

        //Build Twitter share link and info
        var twShareUrl = encodeURIComponent(twShare);
        var twVoteTextUrl = encodeURIComponent(twVoteText);

        scope.twShareUrl = twShareUrl;
        scope.twitterVoteText = twVoteTextUrl;

        var voteLimit = parseInt(
            this.controller.Models.Cms.get('settings').vote_limit,
            10
        );
        var votesLeft =
            voteLimit - this.controller.Models.Auth.getSubmittedVotes();

        //Add CMS data to the scope object
        scope.text = text;
        scope.design = design;
        scope.shareSettings = shareSettings;
        scope.votesLeft = votesLeft;

        _.extend(scope, model);

        console.log('extended scope: ', scope);

        this.$el.html(template(scope));

        return this;
    },

    buildFacebookShareURL: function() {
        var data = this.controller.Models.Cms.get('social').fb.share;

        return 'https://www.facebook.com/dialog/share?' +
            'app_id=' + this.controller.Models.Facebook.get('appId') +
            '&display=popup' +
            '&href=' + data.link +
            '&quote=' + data.description +
            '&redirect_uri=' + data.redirect_uri;
    },

    routeFacebook: function(e) {
        e.preventDefault();

        var shareURL = this.buildFacebookShareURL();
        const width = 520;
        const height = 360;
        const leftPosition = (window.screen.width / 2) - ((width / 2));
        const topPosition = (window.screen.height / 2) - ((height / 2));
        window.open( shareURL, 'sharer', 'top=' + topPosition + ',left=' + leftPosition + ',toolbar=0,status=0,width=' + width + ',height=' + height);

        var evt = {
            category: 'Button Click',
            action: 'Button Click: Share Facebook',
            label: 'Button Click: Share Facebook'
        };

        PubSub.trigger('trackGoogle', evt);
    },

    routeTwitter: function() {
        var evt = {
            category: 'Button Click',
            action: 'Button Click: Share Twitter',
            label: 'Button Click: Share Twitter'
        };

        PubSub.trigger('trackGoogle', evt);
    },

    close: function() {
        PubSub.trigger('modal:close');
    }
});



// WEBPACK FOOTER //
// ./app/scripts/views/thanks.js